import { Link } from 'react-router-dom';
import { Envelope as Mail } from "@phosphor-icons/react";

const LINKEDIN_URL = 'https://www.linkedin.com/company/payday-relay';
const INSTAGRAM_URL = 'https://www.instagram.com/paydayrelay';
const YOUTUBE_URL = 'https://www.youtube.com/@PaydayRelay';

const InstagramIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608C4.519 2.567 5.786 2.293 7.152 2.231 8.418 2.175 8.796 2.163 12 2.163zm0 1.802c-3.148 0-3.51.012-4.744.068-.98.045-1.74.204-2.31.774-.57.57-.729 1.33-.774 2.31C4.116 8.35 4.104 8.712 4.104 12s.012 3.65.068 4.884c.045.98.204 1.74.774 2.31.57.57 1.33.729 2.31.774 1.234.056 1.596.068 4.744.068s3.51-.012 4.744-.068c.98-.045 1.74-.204 2.31-.774.57-.57.729-1.33.774-2.31.056-1.234.068-1.596.068-4.884s-.012-3.65-.068-4.884c-.045-.98-.204-1.74-.774-2.31-.57-.57-1.33-.729-2.31-.774-1.234-.056-1.596-.068-4.744-.068zm0 3.063a4.972 4.972 0 110 9.944 4.972 4.972 0 010-9.944zm0 1.802a3.17 3.17 0 100 6.34 3.17 3.17 0 000-6.34zm6.336-2.01a1.161 1.161 0 11-2.323 0 1.161 1.161 0 012.323 0z"/>
  </svg>
);

const YouTubeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M23.498 6.186a3.02 3.02 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.02 3.02 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.02 3.02 0 002.121 2.136C4.495 20.455 12 20.455 12 20.455s7.505 0 9.376-.505a3.02 3.02 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.546 15.568V8.432L15.818 12l-6.272 3.568z"/>
  </svg>
);

const LinkedInIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

export const SiteFooter = () => (
  <footer className="pt-14 pb-16 px-4 sm:px-6 lg:px-8" style={{ background: '#1E1640' }}>
    <div className="max-w-6xl mx-auto">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-8">
        {/* Column 1: brand */}
        <div>
          <img
            src="/images/paydayrelay-all-white.png"
            alt="Payday Relay"
            className="h-[50px] w-auto mb-5"
            loading="lazy"
          />
          <div className="flex items-center gap-3 mb-5">
            <a
              href="mailto:support@paydayrelay.com"
              className="p-2.5 rounded-full transition-opacity hover:opacity-80"
              style={{ background: 'rgba(255,255,255,0.1)' }}
              aria-label="Email support"
              data-testid="footer-email-link"
            >
              <Mail className="w-5 h-5 text-white" />
            </a>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 rounded-full transition-opacity hover:opacity-80"
              style={{ background: 'rgba(255,255,255,0.1)' }}
              aria-label="LinkedIn"
              data-testid="footer-linkedin-link"
            >
              <LinkedInIcon className="w-5 h-5 text-white" />
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 rounded-full transition-opacity hover:opacity-80"
              style={{ background: 'rgba(255,255,255,0.1)' }}
              aria-label="Instagram"
              data-testid="footer-instagram-link"
            >
              <InstagramIcon className="w-5 h-5 text-white" />
            </a>
            <a
              href={YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 rounded-full transition-opacity hover:opacity-80"
              style={{ background: 'rgba(255,255,255,0.1)' }}
              aria-label="YouTube"
              data-testid="footer-youtube-link"
            >
              <YouTubeIcon className="w-5 h-5 text-white" />
            </a>
          </div>
          <p className="font-body text-[11px] text-white/40 leading-relaxed" data-testid="footer-trademark-line">
            Payday Relay™ — trademark pending.
          </p>
          <p className="font-body text-[11px] text-white/40 leading-relaxed mt-2">
            © 2026 Earthwise Digital LLC. Payday Relay and Payday Relay Method are proprietary educational frameworks and product assets of Earthwise Digital LLC. All rights reserved.
          </p>
        </div>

        {/* Column 2: connect */}
        <div>
          <p className="font-body text-xs font-bold uppercase tracking-[0.2em] mb-4" style={{ color: '#F5CB5C' }}>
            Connect
          </p>
          <ul className="space-y-2.5 font-body text-sm">
            <li><Link to="/partnerships" className="text-white/80 hover:text-white transition-colors" data-testid="footer-partnerships-link">Partnerships</Link></li>
            <li><Link to="/press" className="text-white/80 hover:text-white transition-colors" data-testid="footer-press-link">Press Kit</Link></li>
            <li>
              <a href="mailto:support@paydayrelay.com" className="text-white/80 hover:text-white transition-colors" data-testid="footer-support-link">
                Support
              </a>
            </li>
          </ul>
        </div>

        {/* Column 3: explore */}
        <div>
          <p className="font-body text-xs font-bold uppercase tracking-[0.2em] mb-4" style={{ color: '#F5CB5C' }}>
            Explore
          </p>
          <ul className="space-y-2.5 font-body text-sm">
            <li><Link to="/features" className="text-white/80 hover:text-white transition-colors" data-testid="footer-features-link">Features</Link></li>
            <li><Link to="/compare" className="text-white/80 hover:text-white transition-colors" data-testid="footer-compare-link">Compare</Link></li>
            <li><Link to="/whats-new" className="text-white/80 hover:text-white transition-colors" data-testid="footer-whats-new-link">What's New</Link></li>
          </ul>
        </div>

        {/* Column 4: legal */}
        <div className="lg:text-right">
          <p className="font-body text-xs font-bold uppercase tracking-[0.2em] mb-4" style={{ color: '#F5CB5C' }}>
            Legal
          </p>
          <ul className="space-y-2.5 font-body text-sm">
            <li><Link to="/privacy" className="text-white/80 hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-white/80 hover:text-white transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy#google-data" className="text-white/80 hover:text-white transition-colors" data-testid="footer-google-data-link">How We Use Google Data</Link></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
